// Default album artwork for music channels
import defaultAlbumArt from '../assets/images/default-album-art-main.png';

export const DEFAULT_ALBUM_ART = defaultAlbumArt;

/**
 * Get the artwork for a channel, falling back to default if none is provided
 * @param artwork - The channel's artwork URL
 * @returns The artwork URL or default artwork
 */
export const getChannelArtwork = (artwork?: string): string => {
  return artwork || DEFAULT_ALBUM_ART;
};

/**
 * Check if the artwork is the default artwork
 * @param artwork - The artwork URL to check
 * @returns True if it's the default artwork
 */
export const isDefaultArtwork = (artwork: string): boolean => {
  return artwork === DEFAULT_ALBUM_ART;
};
